import { createPost } from "blog/post"
import { NodeKind } from "blog/json_nodes"
import { createExternalLink } from "blog/components/link"

export const DarrellLeaLicoriceDarkChocolateBlock = createPost({
  kind: NodeKind.POST,
  tags: ['food', 'recommendations'],
  title: "Darrell Lea Licorice Dark Chocolate Block",
  date: "2020-06-01T:15:30:00.0000Z",
  content: `Disclaimer, I like licorice. If you don't like licorice that's totally fine, it's okay to be wrong. This post is a PSA that Darrell Lea Licorice Dark Chocolate Block's are pretty dang good. Here's a <a target="_blank" href="https://www.amazon.com/gp/product/B07N96Q7GB/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07N96Q7GB&linkCode=as2&tag=kaveh01-20&linkId=549b752d374804b3c4b59599b07622ae">different product</a><img
    src="//ir-na.amazon-adsystem.com/e/ir?t=kaveh01-20&l=am2&o=1&a=B07N96Q7GB" width="1" height="1" border="0" alt="" style="border:none !important; margin:0px !important;" /> that's similar I guess.`,
  relatedPosts: [],
  references: [
    createExternalLink(
      "darrell lea official website",
      "https://dlea.com.au/products/liquorice-dark-chocolate",
    ),
  ],
  ads: [
    {
      iframe: `<iframe style="width:120px;height:240px;" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=kaveh01-20&marketplace=amazon&region=US&placement=B07N96Q7GB&asins=B07N96Q7GB&linkId=04ed9d9bed1667b3077cf90ee30a0d67&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff"></iframe>`,
    },
  ],
})
